import { useMemo } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { RosterDisplayControls } from "./roster-display-controls";
import { RosterFilterEmptyState } from "./roster-filter-empty-state";
import { RosterReadOnlyTable } from "./roster-read-only-table";
import type { PayrollRoster } from "./types";
import { useRosterFilters } from "./use-roster-filters";

export const RosterReadOnlyView = ({
  roster,
  businessId,
}: {
  roster: PayrollRoster;
  businessId: string;
}) => {
  const rows = useMemo(
    () => roster.members.map((member) => ({ member })),
    [roster.members],
  );
  const filters = useRosterFilters(rows, roster.fields, {
    teams: roster.available_teams,
    businessId,
  });
  const members = useMemo(
    () => filters.filteredRows.map(({ member }) => member),
    [filters.filteredRows],
  );
  return (
    <Stack gap={0} className="min-h-0 w-full flex-1">
      <Stack
        align="start"
        gap={4}
        className="w-full shrink-0 border-b px-4 py-3"
      >
        <RosterDisplayControls {...filters.controls} />
      </Stack>
      {filters.hasActiveFilters && members.length === 0 ? (
        <RosterFilterEmptyState
          search={filters.search}
          activeFilterCount={filters.activeFilterCount}
          onClear={filters.clearFilters}
        />
      ) : (
        <RosterReadOnlyTable
          key={filters.filterKey}
          fields={roster.fields}
          members={members}
        />
      )}
    </Stack>
  );
};
